module.exports = __webpack_public_path__ + "static/tutorial-53139a7dd8a8a35d2df015e6eb89d411.jpg";